import { LangString } from "@/types/api";

export interface NotificationItem {
  id: string;
  createdAt: string;
  isRead: boolean;
  type: string;
  description?: LangString;
  data?: Record<string, unknown>;
}

export interface RecentCallData {
  callId: string;
  direction: "inbound" | "outbound";
  toPhoneNumber: string;
  fromPhoneNumber: string;
}

export function isRelativeUrl(url: string): boolean {
  return url.startsWith("/") && !url.startsWith("//");
}

export interface NotificationPage {
  notifications: NotificationItem[];
  nextCursor: number | null;
  total: number;
}
